import React from 'react';
import ThemeProvider from 'components/ThemeProvider';
import ThemeSection from 'components/ThemeSection';
import getBaseTheme from 'styles/getBaseTheme';
var baseTheme = getBaseTheme();
function PageThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: baseTheme
  }, /*#__PURE__*/React.createElement(ThemeSection, {
    name: "page"
  }, children));
}
export default PageThemeProvider;